var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('t-dropdown',{attrs:{"variant":"tooltip","toggle-on-hover":""}},[_vm._t("default",null,{"slot":"trigger"}),[_vm._v(" "+_vm._s(_vm.tooltipText)+" ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }